











































































import { Component, Prop, Vue } from "vue-property-decorator";
import { CalendarData, Properties, SessionSolutionProperties } from "../types";
import BookingModal from "./BookingModal.vue";
import ExtendModal from "./ExtendModal.vue";
import CancelModal from "./CancelModal.vue";
import moment from "moment";

@Component({
    components: {
        "booking-modal": BookingModal,
        "extend-modal": ExtendModal,
        "cancel-modal": CancelModal
    }
})
export default class SideButtons extends Vue {
    @Prop() currentMeeting!: CalendarData | null;
    @Prop() translations!: any;
    @Prop() isBookingDisabled!: boolean;
    @Prop() screenOn!: boolean;
    @Prop() properties!: Properties;
    @Prop() now!: moment.Moment;
    @Prop() nextMeeting!: CalendarData;
    @Prop() preview!: boolean;
    @Prop() hub!: any;
    @Prop() subscriptionStarted!: boolean;
    @Prop() timeUntilNextMeeting!: number;
    @Prop() meetingToConfirm!: CalendarData | null;
    @Prop() solutionProperties!: SessionSolutionProperties

    loading = "";
    loadingTimer = 0;

    get roomEmail() {
        return this.solutionProperties.roomEmail;
    }

    get buttonStyle() {
        return `background: ${this.properties.buttonColor};`;
    }

    startMeetingEarly() {
        if (this.timeUntilNextMeeting) {
            const endTime = moment(this.nextMeeting.EndDateTime);
            const startTime = moment().set("seconds", 0).set("milliseconds", 0);
            this.hub.invoke("RescheduleAppointment", this.nextMeeting.Id, startTime.toISOString(), endTime.toISOString(), this.roomEmail).done(() => {
                this.nextMeeting.LastUpdated = startTime.toISOString();
                this.nextMeeting.StartDateTime = startTime.toISOString();
            });
        }
    }

    confirmMeeting() {
        if (this.meetingToConfirm) {
            const endTime = moment(this.meetingToConfirm.EndDateTime);
            const startTime = moment(this.meetingToConfirm.StartDateTime).set("seconds", 1).set("milliseconds", 0);
            this.hub.invoke("RescheduleAppointment", this.meetingToConfirm.Id, startTime.toISOString(), endTime.toISOString(), this.roomEmail).done(() => {
                this.$emit("confirmMeeting", startTime.toISOString());
            });
        }
    }

    loadData() {
        this.$emit("loadData");
    }

    setLoading(value: string) {
        this.loading = value;
    }

    openBookingModal() {
        (this.$refs.bookingModal as any).open();
    }

    openExtendModal() {
        if (this.currentMeeting && this.currentMeeting.Id) (this.$refs.extendModal as any).open();
    }

    openCancelModal() {
        if (this.currentMeeting && this.currentMeeting.Id) (this.$refs.cancelModal as any).open();
    }

    turnOn() {
        this.$emit("turnOn");
    }

    turnOff() {
        this.$emit("turnOff");
    }
}
